export const convertCoinsToMoney = ({ coins, denominationValue = 100 }) => {
  return (coins / denominationValue).toFixed(2); // Assuming 2 decimal places for dollars
};
